import React from 'react';

import { usePortalDomain } from '@portals/framework';

import BrowserMock from '../../../components/OnboardingWizard/BrowserMock';
import { SignInBrowserMock } from '../../../components/OnboardingWizard/SignInBrowserMock';
import { useBrandingContext } from '../branding.context';

export function CustomerPortalPreview() {
  const portalDomain = usePortalDomain();
  const { portalConfig } = useBrandingContext();

  return (
    <div className="browser-mock-wrapper">
      <BrowserMock portalConfig={portalConfig} domain={portalDomain}>
        <SignInBrowserMock portalConfig={portalConfig} />
      </BrowserMock>
    </div>
  );
}
